@if (_active) {
  <kendo-window title="{{ _isNew ? 'Add new record' : 'Edit' }}" (close)="_closeForm()"
    (stateChange)="_onStateChanges($event)">
    <form novalidate [formGroup]="_form" class="form_style">
      <div class="row special_row_margin">
        <div class="col-12 special_col_padding">
          <div class="border_sections margin-top-4">
            <div class="k-block">
              <h2>Dispose To</h2>
              <div class="right_buttons">
                <br />
                <div class="row bottom_buttons">
                  <div class="col-xs-12">
                    <button class="hidden-xs" kendoButton (click)="_onSave($event)">
                      <span><img [src]="'/assets/menu/'+ _theme +'/save-close-icon.svg'" /></span>Save
                      & Close
                    </button>
                  </div>
                  <div class="col-xs-12 visible-xs">
                    <div class="xs_menue_list">
                      <button class="z_10" kendoButton>
                        <span><img [src]="'/assets/menu/'+ _theme +'/close-icon.svg'" /></span><span class="hidden-xs">Close</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row row_padding">
              <fieldset class="col-12 col-xl-6">
                <div class="form-group from_but_container special_style_formgroup">
                  <label for="customercode" class="control-label">Dispose To ID</label>
                  <asap-barcode-generation formControlName="code" [placeholder]="'Dispose To ID'"
                    [entityName]="'locations'"
                    [icon]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'">
                  </asap-barcode-generation>
                </div>
                <div class="form-group special_style_formgroup">
                  <label for="customername" class="control-label">Dispose To Description</label>
                  <input type="text" class="k-textbox writebox" formControlName="description"
                    placeholder="Dispose To Description" />
                  </div>
                  @if ( !_isNew && (_currentUser && !_currentUser.isEnterprise)) {
                    <div class="form-group special_style_formgroup">
                      <label for="itemType" class="control-label">Account</label>
                      <accounts-dropdown [formControl]="_selectedAccount"
                        class="required-input current-step k-combobox"
                        [class.active]="_selectedAccount.value == null"
                        [required]="true">
                      </accounts-dropdown>
                    </div>
                  }
                  @if ( !_isNew) {
                    <div class="form-group special_style_formgroup">
                      <label for="itemType" class="control-label">Site</label>
                      <sites-dropdown class="required-input current-step k-combobox"
                        [forceShow]="!_currentUser?.isEnterprise"
                        [disabled]="_selectedAccount.value == null"
                        [placeholder]="'Choose a Site'"
                        formControlName="site"
                        [textField]="'name'"
                        [valueField]="'id'"
                        [class.active]="_selectedAccount.value != null && _form.get('site').value == null"
                        [required]="true"
                        (siteChanged)="_sitesSelectionChanged($event)">
                      </sites-dropdown>
                    </div>
                  }
                </fieldset>
                @if ( !_isNew && (_currentUser && !_currentUser.isEnterprise)) {
                  <div class="col-12 col-xl-6 appliance-Sharts-Container">
                    <div class="tabsSection">
                      <ul class="tabsectionList">
                        <li [class.activetabShart]="_SIActive" (click)="_SITabClick()" class="LS">Stock item</li>
                      </ul>
                    </div>
                    @if (_SIActive) {
                      <div class="clickablelayer" (click)="_SITabClick()"></div>
                    }
                    @if (_SIActive) {
                      <kendo-chart>
                        <kendo-chart-title text="Stock Item"></kendo-chart-title>
                        <kendo-chart-category-axis>
                          <kendo-chart-category-axis-item [categories]="NbrOfDisposedItems.dates">
                          </kendo-chart-category-axis-item>
                        </kendo-chart-category-axis>
                        <kendo-chart-legend position="bottom" orientation="horizontal">
                          <kendo-chart-legend-inactive-items></kendo-chart-legend-inactive-items>
                        </kendo-chart-legend>
                        <kendo-chart-series>
                          <kendo-chart-series-item type="bar" [data]="NbrOfDisposedItems.quantities">
                          </kendo-chart-series-item>
                        </kendo-chart-series>
                      </kendo-chart>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            @if (_invalidForm) {
              <asap-forms-validation-summary [form]="_form" [page]="'locations'">
              </asap-forms-validation-summary>
            }
          </div>
        </div>
      </form>
    </kendo-window>
  }
